import angular from 'angular';
import guid from '../../../shared/utils/guid';

angular.module('cloudX').directive('cxRelationGroupPicker', [
  '$filter',
  '$rootScope',
  '$http',
  'appUrls',
  function($filter, $rootScope, $http, appUrls) {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      template: `<div>
        <tags-input
          ng-model="selected"
          placeholder="{{('RelationGroups'|translate)}}"
          display-property="name"
          key-property="{{keyProperty}}"
          on-tag-added="updateValue()"
          on-tag-removed="updateValue()"
          replace-spaces-with-dashes="false"
          add-from-autocomplete-only="true"
          min-length="1"
          class="bootstrap">
          <auto-complete
            source="getSuggestions($query)"
            load-on-focus="true"
            load-on-empty="true"
            display-property="name"
            min-length="0"></auto-complete>
        </tags-input>
      </div>`,
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;
        $scope.keyProperty = attrs.keyProperty || 'id';
        $scope.showWithoutGroups = attrs.showWithoutGroups || false;

        $scope.selected = [];
        $scope.options = [];
        $scope.loaded = false;
        $scope.tmpValue = null;
        var findOption = function(code) {
          if (code == null || $scope.options.length === 0) return null;
          return $scope.options.find(function(el) {
            return el[$scope.keyProperty] === code;
          });
        };

        $scope.loadGroups = function() {
          return $http.get(`${appUrls.api}/api/RelationGroup/GetAll`).then(({ data }) => {
            $scope.options = data || [];
            if ($scope.showWithoutGroups) {
              $scope.options.unshift({
                id: guid.empty,
                name: $filter('translate')('WithoutRelationGroup'),
              });
            }
            if ($scope.tmpValue) {
              $scope.selected = $scope.tmpValue.map(x => findOption(x));
              $scope.tmpValue = null;
            }
            $scope.loaded = true;
          });
        };

        $scope.getSuggestions = function(search) {
          if (!$scope.loaded)
            return $scope.loadGroups().then(() => {
              return $filter('filter')($scope.options, search);
            });
          return $filter('filter')($scope.options, search);
        };

        $scope.updateValue = function() {
          ngModel.$setViewValue(
            attrs.objectAsModel ? $scope.selected : $scope.selected.map(x => x[$scope.keyProperty]),
          );
        };

        ngModel.$render = function() {
          var value = ngModel.$viewValue;
          if (value !== null && typeof value !== 'undefined' && angular.isArray(value)) {
            if (!$scope.loaded) {
              $scope.tmpValue = value;
              $scope.loadGroups();
            } else {
              $scope.selected = value.map(x => findOption(x));
            }
          }
        };
      },
    };
  },
]);
